import React, {Fragment, Suspense, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
// import {useRouter} from 'core/hooks';
import {Spinner} from 'core/uicore';
import {login} from '../redux/actions/coreActions';
const ProQuote = React.lazy(() => import('custom/proQuote/ProQuote'));

const Routes = ({...props}) => {
  const {isAuthenticated, controlItems} = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    controlItems: state.setupItems.controlItems,
  }));

  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(login('ProQuote', 'ProQuote1'));
    
  }, []);

  if (!controlItems || !isAuthenticated) {
    return <Spinner />;
  }
  return (
    <Suspense fallback={<Spinner />}>
      <ProQuote {...props} />
    </Suspense>
  );
};

// export default withAutoLogout(Routes);
export default Routes;
